module.exports = __webpack_public_path__ + "img/img-box-3.1976ab40.png";